import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import functions from "./functions";

createApp(App).use(router).use(functions).mount('#app');
